"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "../../styles.module.scss";
import JobSearchBar from "../../JobSearchBar";
import ExptereerAd from "../../ExperteerAd";
import ExpiredJobSource from "./ExpiredJobSource";
import { JobDetailType } from "@/app/career/view-jobs/[id]/type";
import JobSummary from "../../JobSummary";
function JobContainerExpired(t0) {
  const $ = _c(13);
  const {
    jobDetail
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className={`${styles.maxWidth} flex-shrink-0 flex-grow-0`}><JobSearchBar /></section>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== jobDetail) {
    t2 = <JobSummary content={jobDetail} isSummaryLimited={true} jobStatus="expired" />;
    $[1] = jobDetail;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ExptereerAd type="expired" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <main className={styles.main}><div className="relative">{t2}{t3}</div></main>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== jobDetail) {
    t5 = jobDetail?.posterInfo && <ExpiredJobSource posterInfo={jobDetail.posterInfo} />;
    $[6] = jobDetail;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className={`${styles.asideWidth} hidden md:block`}>{t5}</div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <>{t1}<div className={`${styles.maxWidth} flex-shrink flex-grow md:flex flex-nowrap gap-x-2.5 pt-[10px]`}>{t4}{t6}</div></>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
export default JobContainerExpired;